import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type OpenPowerOfAttorneyMutationVariables = Types.Exact<{
  powerOfAttorneyBaseInput: Types.PowerOfAttorneyBaseInput
}>

export type OpenPowerOfAttorneyMutation = {
  __typename?: 'Mutation'
  createOrUpdatePowerOfAttorney: {
    __typename?: 'PowerOfAttorney'
    uid: string
    state: Types.PowerOfAttorneyState
    deliveryMethod: Types.DeliveryMethod
  }
}

export const OpenPowerOfAttorneyDocument = gql`
  mutation OpenPowerOfAttorney($powerOfAttorneyBaseInput: PowerOfAttorneyBaseInput!) {
    createOrUpdatePowerOfAttorney(powerOfAttorneyBaseInput: $powerOfAttorneyBaseInput) {
      uid
      state
      deliveryMethod
    }
  }
`
export type OpenPowerOfAttorneyMutationFn = ApolloReactCommon.MutationFunction<
  OpenPowerOfAttorneyMutation,
  OpenPowerOfAttorneyMutationVariables
>
export function useOpenPowerOfAttorneyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OpenPowerOfAttorneyMutation,
    OpenPowerOfAttorneyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    OpenPowerOfAttorneyMutation,
    OpenPowerOfAttorneyMutationVariables
  >(OpenPowerOfAttorneyDocument, options)
}
export type OpenPowerOfAttorneyMutationHookResult = ReturnType<
  typeof useOpenPowerOfAttorneyMutation
>
export type OpenPowerOfAttorneyMutationResult =
  ApolloReactCommon.MutationResult<OpenPowerOfAttorneyMutation>
export type OpenPowerOfAttorneyMutationOptions = ApolloReactCommon.BaseMutationOptions<
  OpenPowerOfAttorneyMutation,
  OpenPowerOfAttorneyMutationVariables
>
